import React from "react"
import { diff_in_days } from "../../../../utils/dates/diff_in_days"

// @ts-ignore
import style from "./index.module.sass"
import { Venue } from "../../../../../types/venue";
import { isNewVenue, MAX_DAYS_TO_BE_NEW } from "../../../../utils/VenuesUtilities";


// @ts-ignore
const I18n = window.I18n

type Props = {
  venue: Venue
}

const VenueBadges = (props: Props) => {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { venue } = props
  const { first_published_at, promotion, priority, coming_soon_at, exclusive } = venue

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const isNew = isNewVenue(venue)

  // -------------------------------------

  if (!isNew && !promotion && !(priority > 0) && !coming_soon_at && !exclusive) {
    return <div></div>
  }

  return (
    <div className={style.venueBoxBadges}>
      {isNew && (
        <span className={`${style.badge} ${style.badgeLightOrange}`}>
          {I18n.t("pages.locations.venues.venue_box.new")}
        </span>
      )}
      {promotion && (
        <span className={`${style.badge} ${style.badgePink}`}>
          {I18n.t("pages.locations.venues.venue_box.promotion")}
        </span>
      )}
      {priority > 0 && (
        <span className={`${style.badge} ${style.badgeLightBlue}`}>
          {I18n.t("pages.locations.venues.venue_box.sponsored")}
        </span>
      )}
      {coming_soon_at && (
        <span className={`${style.badge} ${style.badgeDarkBlue}`}>
          {I18n.t("pages.locations.venues.venue_box.coming_at_future")}
        </span>
      )}
      {exclusive && (
        <span className={`${style.badge} ${style.badgeOrange}`}>
          {I18n.t("pages.locations.venues.venue_box.exclusive")}
        </span>
      )}
    </div>
  )
}

export default VenueBadges